import type { AxiosRequestConfig } from 'axios';
import { ElMessage } from 'element-plus';
import service from '@/api/request';
import { download } from '@/utils';

/** 下载扩展名类型 */
type ExportExt = Exclude<keyof typeof download, 'downloadFile'>;

/** 定义导出接口 */
export function defineExportApi<T extends Record<string, any>>(url: string, ext: ExportExt = 'excel') {
  return async (params: T) => {
    const { data, headers } = await service.post(url, params, { download: 'origin' });
    const contentDisposition = headers['content-disposition'] as string;
    const fileNameDef = contentDisposition
      ?.split(';')
      .map(item => item.trim())
      .find(item => item.startsWith('filename'));
    const fileName = fileNameDef?.split('=')[1];
    if (fileName) {
      download[ext](data, decodeURIComponent(fileName));
    } else {
      ElMessage.error('导出失败，请联系管理员');
    }
  };
}

/** 定义普通post接口 */
export function definePostApi<Req = unknown, Res = unknown>(url: string) {
  const fn = (params: Req, opts?: AxiosRequestConfig) => service.post<Req, Res>(url, params, opts);
  fn.$url = url;
  fn.$pureUrl = url.replace(/^\/api/, '');
  return fn;
}
